import classnames from 'classnames';
import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import noDataIcon from '@/shared/ui/icons/Tables/no-data-icon.svg';
import notFoundIcon from '@/shared/ui/icons/Tables/not-found-icon.svg';
import { NormalButton } from '@/shared/ui';

export type NoDataComponentProps = {
  isSearching?: boolean;
  message?: string;
  hasButton?: boolean;
  buttonName?: string;
  isSaving?: boolean;
  onClick?: () => void;
  hasTryButton?: boolean;
  onClickTry?: () => void;
  studyFid?: string;
  isFilledBtn?: boolean;
  className?: string;
  isAbortedStudy?: boolean;
  buttonId?: string;
};

const NoDataComponent = ({
  isSearching = false,
  message,
  hasButton = false,
  buttonName = '',
  isSaving = false,
  onClick = () => {},
  hasTryButton = false,
  onClickTry = () => {},
  studyFid,
  isFilledBtn = false,
  className,
  isAbortedStudy = false,
  buttonId,
}: NoDataComponentProps) => (
  <div className={classnames('no-data-container', className)}>
    <img
      className="no-data__icon"
      src={isSearching ? notFoundIcon : noDataIcon}
      alt="No data icon"
    />
    <div className="no-data__text">
      <div>
        {message ||
          (isSearching
            ? hasTryButton
              ? 'We couldn’t find any events matching'
              : 'No result found'
            : 'There is no data to display')}
      </div>
      {isSearching && hasTryButton && <div>{`"${studyFid}"`}</div>}
    </div>
    {hasButton && (
      <div className="mt4">
        <NormalButton
          buttonName={buttonName}
          isSaving={isSaving}
          onClick={onClick}
          isFilled={isFilledBtn}
          id={buttonId}
          disabled={isAbortedStudy}
        />
        {isAbortedStudy && (
          <UncontrolledTooltip
            className="custom-tooltip"
            target={buttonId}
            placement="bottom"
            delay={{ show: 0, hide: 0 }}
            hideArrow
          >
            Cannot create report for an aborted study.
          </UncontrolledTooltip>
        )}
      </div>
    )}
    {isSearching && hasTryButton && (
      <NormalButton
        buttonName="Try a different keyword"
        className="try-btn"
        isText
        onClick={onClickTry}
      />
    )}
  </div>
);

export default NoDataComponent;
